import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_URL,
  PERCENTAGE_DISCOUNT_CHART,
  PERCENTAGE_DISCOUNT_CHART_NEW,
  REPORTS_DISCOUNT_PERCENTAGE,
  REPORTS_BASE_URL,
  IS_PY_GRAPHS,
  UPDATE_DISCOUNT_PERCENTAGE_RUN_TIME_DATA,
} from "../../../../Constants/Config";
import { useAuthDetails } from "../../../../Common/cookiesHelper";

const initialState = {
  loading: true,
  percentageDiscountData: [],
  totalPercentageDiscount: 0,
  previousWeekDiscountPercent: 0,
  error: "",
  isCancel: false,
  lastRequestPayload: null,
};
let controller = null;

export const getPercentageDiscount = createAsyncThunk(
  "percentageDiscountChart/getPercentageDiscount",
  // async (data, { rejectWithValue }) => {
  async (data, { rejectWithValue }) => {
    const { userTypeData } = useAuthDetails();
    if (controller) {
      controller.abort();
    }

    // Create a new AbortController instance for the current request
    controller = new AbortController();

    try {
      const { token, ...otherUserData } = userTypeData;

      const requestData = { ...(data || {}) };
      const activeType =
        requestData?.activeType || requestData?.view_by || requestData?.date_type;
      const isWeek = String(activeType || "").toLowerCase() === "week";


      if (isWeek) {
        const minusOneDay = (dateStr) => {
          const date = new Date(dateStr);
          date.setDate(date.getDate());
          return date.toISOString().split("T")[0]; // YYYY-MM-DD
        };

        requestData["date_range"] = `${minusOneDay(requestData.start_date)}_${minusOneDay(requestData.end_date)}`;

      }

      const endpoint = PERCENTAGE_DISCOUNT_CHART_NEW;

      const apiUrl =
        IS_PY_GRAPHS === true || IS_PY_GRAPHS === "true"
          ? REPORTS_BASE_URL + REPORTS_DISCOUNT_PERCENTAGE
          : BASE_URL + endpoint;
      const response = await axios.post(
        // BASE_URL + PERCENTAGE_DISCOUNT_CHART,
        apiUrl,
        { ...requestData, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        }
      );

      // console.log("discount api: ", response);
      return response.data;
    } catch (error) {
      if (axios.isCancel(error) || error.name === "CanceledError") {
        return rejectWithValue({ isCanceled: true }); // Mark as canceled
      }
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const percentageDiscountChartSlice = createSlice({
  name: "percentageDiscountChart",
  initialState,
  reducers: {
    clearPercentageDiscountChart: (state, action) => {
      state.loading = true;
      state.percentageDiscountData = [];
      state.totalPercentageDiscount = 0;
      state.previousWeekDiscountPercent = 0;
      state.error = "";
      state.isCancel = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPercentageDiscount.pending, (state, action) => {
      state.loading = true;
      state.isCancel = false;
      // Store the request payload for later use
      state.lastRequestPayload = action.meta.arg || null;
    });
    builder.addCase(getPercentageDiscount.fulfilled, (state, action) => {
      state.loading = false;
      state.percentageDiscountData = action.payload?.discount_per_data || [];
      state.totalPercentageDiscount = action.payload?.total_discount_per || 0;
      state.previousWeekDiscountPercent = action.payload?.previous_discount_per || 0;
      state.error = "";
      state.isCancel = false;
    });
    builder.addCase(getPercentageDiscount.rejected, (state, action) => {
      state.loading = false;
      state.percentageDiscountData = [];
      state.totalPercentageDiscount = 0;
      state.previousWeekDiscountPercent = 0;
      state.error = action.error.message;
      state.isCancel = action.payload?.isCanceled;
      state.lastRequestPayload = null;
    });
  },
});

export const { clearPercentageDiscountChart } =
  percentageDiscountChartSlice.actions;
export default percentageDiscountChartSlice.reducer;
